import { CURRENT_SCHEMA, DataSnapshot } from '@/types/domain';

export const seedSnapshot: DataSnapshot = {
  version: CURRENT_SCHEMA,
  tenant: { id: 'default-tenant', name: 'Default Tenant', plan: 'Free', seats: 1 },
  users: [],
  clients: [],
  cases: [],
  whiteboards: [],
};
